import { Grid, TextField } from '@mui/material';

const CompanyAddressSection = ({ t, userData, errorMessage, countriesMap, onSetAddress }) => (
  <Grid className="personal-data__card">
    <h4 className="sub_head">{t('personalData.companyaddress')}</h4>
    <Grid className="personal-data__card-head">
      <Grid>
        <TextField
          error={errorMessage.address}
          label={t('personalData.Street')}
          placeholder={t('personalData.Street')}
          fullWidth
          className="personal-data__text-field"
          margin="normal"
          value={(userData && userData.address)?.street || ''}
          onChange={onSetAddress}
          name="street"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid>
        <TextField
          label={t('personalData.Postcode')}
          placeholder={t('personalData.Postcode')}
          className="personal-data__text-field"
          value={(userData && userData.address)?.postalCode || ''}
          onChange={onSetAddress}
          name="postalCode"
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid>
        <TextField
          error={errorMessage.address}
          label={t('personalData.city')}
          placeholder={t('personalData.city')}
          className="personal-data__text-field"
          margin="normal"
          fullWidth
          value={(userData && userData.address)?.city || ''}
          onChange={onSetAddress}
          name="city"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid>
        <TextField
          label={t('personalData.country')}
          placeholder={t('personalData.country')}
          className="personal-data__text-field personal-data__text-field--readonly"
          margin="normal"
          fullWidth
          value={userData?.address?.country ? countriesMap.get(userData.address.country) : ''}
          name="country"
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid>{errorMessage.address ? <div className="errorMessageInput">{errorMessage.address}</div> : null}</Grid>
    </Grid>
  </Grid>
);

export default CompanyAddressSection;
